import { RouterProvider } from "react-router-dom";
import { router } from "@/router/routes";
import { ToastProvider } from "@/contexts/ToastContext";
import { ConfirmDialogProvider } from "@/contexts/ConfirmDialogProvider";

function App() {
  return (
    <ToastProvider>
      <ConfirmDialogProvider>
        <RouterProvider router={router} />
      </ConfirmDialogProvider>
    </ToastProvider>
  );
}

export default App;
